const config = {
  headerImageUrl: 'https://res.cloudinary.com/dav8yugzm/image/upload/v1666205714/Hunter2_wkphzj.jpg'
}


export default config
